export default "__VITE_ASSET__WLGw4DvS__"